// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__33-8u","choiceBoxes":"toolbarselects_choiceBoxes__3dX-T","simpleField":"toolbarselects_simpleField__36C7B"};